export default "__VITE_ASSET__DGgy8XjP__"